export default "__VITE_ASSET__002ff2a4__"